/**
 * ============================================================================
 * api.js - Client API
 * ============================================================================
 * 
 * Modulo per la comunicazione con il backend dell'applicazione CRF.
 * Gestisce le chiamate HTTP tramite axios e fornisce funzioni
 * per recuperare dati delle pagine.
 * 
 * USO PRIMARIO:
 * • Recupero dati pagina dal backend
 * • Gestione timeout e headers standardizzati
 * • Error handling centralizzato
 * 
 * CONFIGURAZIONE:
 * Base URL: /api/
 * Timeout: 10 secondi
 * Content-Type: application/json
 * 
 * ============================================================================
 */

// ───────────────────────────────────────────────────────────────────
// IMPORTS
// ───────────────────────────────────────────────────────────────────

import axios from 'axios'

// ───────────────────────────────────────────────────────────────────
// AXIOS CONFIGURATION
// ───────────────────────────────────────────────────────────────────

/**
 * Istanza axios configurata per le chiamate API
 */
const apiClient = axios.create({
  baseURL: '/api/home/',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// ───────────────────────────────────────────────────────────────────
// API FUNCTIONS
// ───────────────────────────────────────────────────────────────────

/**
 * Recupera i dati di una pagina dal backend
 * 
 * Effettua una richiesta GET all'endpoint specificato e restituisce
 * i dati della pagina in formato JSON.
 * 
 * GESTIONE ERRORI:
 * - Log dell'errore in console
 * - Rilancio dell'errore al chiamante per gestione specifica
 * 
 * @param {string} endpoint - Percorso dell'endpoint (es. '/home')
 * @returns {Promise<Object>} Dati della pagina
 * @throws {Error} Errore se la richiesta fallisce
 */
export async function getPageData(endpoint) {
  try {
    const response = await apiClient.get(endpoint)
    return response.data
  } catch (error) {
    console.error(`Errore caricamento ${endpoint}:`, error)
    throw error
  }
}
